import * as React from 'react';

export const AngleIcon: React.FunctionComponent = () => {
  return (
    <svg width="180" height="32" viewBox="0 0 180 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M160 16.0001L19 16" stroke="currentColor" strokeWidth="4" />
      <path
        d="M170 16L156 24L156 8L170 16Z

"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="4"
      />
      <circle cx="12.5" cy="16" r="5" stroke="currentColor" strokeWidth="3" />
    </svg>
  );
};
